var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 3.33203H3.33317C2.414 3.33203 1.6665 4.07953 1.6665 4.9987V14.9987C1.6665 15.9179 2.414 16.6654 3.33317 16.6654H16.6665C17.5857 16.6654 18.3332 15.9179 18.3332 14.9987V4.9987C18.3332 4.07953 17.5857 3.33203 16.6665 3.33203ZM16.6665 4.9987V5.42453L9.99984 10.6104L3.33317 5.42536V4.9987H16.6665ZM3.33317 14.9987V7.53536L9.48817 12.3229C9.6341 12.4375 9.81428 12.4998 9.99984 12.4998C10.1854 12.4998 10.3656 12.4375 10.5115 12.3229L16.6665 7.53536L16.6682 14.9987H3.33317Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmails);
export default __webpack_public_path__ + "static/media/emails.c06cd9cf2d425328258a9455aa870eea.svg";
export { ForwardRef as ReactComponent };